import { render, staticRenderFns } from "./deactivatedClients.vue?vue&type=template&id=348479c8&scoped=true&"
import script from "./deactivatedClients.vue?vue&type=script&lang=js&"
export * from "./deactivatedClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348479c8",
  null
  
)

export default component.exports